import { Fragment } from 'react';
import { Button, Stack, Typography } from '@zurich/ui/atoms';
import { Card, Icon, Seperator } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import type { SummaryDataType } from '~/lib/types';

export interface InfoSummaryCardProps {
  summaryData: SummaryDataType[];
}

export function InfoSummaryCard({ summaryData }: InfoSummaryCardProps) {
  return (
    <CardStyled>
      {summaryData.map((item, i) => (
        <Fragment key={item.title}>
          <Stack
            key={item.title}
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <StackStyled rowGap={1}>
              <Typography variant="caption regular">{item.title}</Typography>
              <Typography variant="body1 medium" color="zurichBlue">
                {item.info}
              </Typography>
            </StackStyled>

            <Stack gap={2} flexDirection="row" alignItems="center">
              <Icon variant="check" color="success" fontSize="medium" />
              <Button icon="pencil" variant="text" onClick={item.onClick} />
            </Stack>
          </Stack>
          {i !== summaryData.length - 1 && <Seperator margin="0" />}
        </Fragment>
      ))}
    </CardStyled>
  );
}

const CardStyled = styled(Card)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
}));

const StackStyled = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(1.5),
  paddingTop: theme.spacing(1.5),
}));
